import React from "react";
import {useTranslation} from "react-i18next";
import "./Navbar.css";
import {BiMenu, BiSolidChevronDown} from "react-icons/bi";
import {Link, useLocation} from "react-router-dom";
import ReactGA from "react-ga4";

const Menu = () => {

        const {pathname} = useLocation();

        // Define your navigation links and their corresponding paths
        const navLinks = [
            {text: 'home', path: '/'},
            {text: 'bulletin', path: '/bulletin'},
            {text: 'finance', path: '/finance'},
            {text: 'external', path: '/external'},
            {text: 'moneymarket', path: '/moneymarket'},
            {text: 'other', path: '/other'},
            {text: 'schedule', path: '/schedule'},
        ];

        // Determine which link is active based on the current pathname
        const activeLink = navLinks.find((link) => link.path === pathname);


        const {t, i18n} = useTranslation();

        const [menuOpen, setMenuOpen] = React.useState(false);
        const [activeMenu, setActiveMenu] = React.useState(activeLink.text);

        const menuClick = (name) => {
            setActiveMenu(name)
            ReactGA.event({
                category: 'Menu',
                action: 'Click',
                label: name
            });
        }

        const handleChangeLanguage = () => {
            const selectedLanguage = i18n.language === 'mn' ? 'en' : 'mn';
            i18n.changeLanguage(selectedLanguage);
        };

        return (
            <>
                {/*<nav className="bg-white border-b-4 border-b-[#163578] shadow-[0_2px_7px_0px_rgb(0,0,0,0.25)] mt-5">*/}
                <nav className="bg-white shadow-[0_2px_7px_0px_rgb(0,0,0,0.25)] mt-5">
                    <div
                        className={menuOpen ? ("container mx-auto lg:flex lg:flex-wrap items-center lg:justify-between") : ("container mx-auto flex flex-wrap items-center justify-between")}>
                        <div className="block lg:hidden p-auto my-auto">
                            <button
                                className="text-[#163578] hover:text-[#163578] focus:outline-none my-auto pt-1"
                                onClick={() => setMenuOpen(!menuOpen)}
                            >
                                {menuOpen && (
                                    <BiSolidChevronDown className={"mx-2"} size={'2em'}/>
                                )}
                                {!menuOpen && (
                                    <BiMenu className={"mx-2"} size={'2em'}/>
                                )}

                            </button>
                        </div>
                        <div
                            className={`${
                                menuOpen ? "block px-8" : "hidden"
                            } lg:block lg:flex lg:justify-between lg:items-center lg:w-auto`}
                        >
                            <ul className="lg:flex lg:items-center lg:space-x-6">
                                <li>
                                    <Link
                                        to={"/"}
                                        className={`text-[#163578] hover:text-[#163578]  uppercase block py-2 px-4  font-bold text-base menu-item ${
                                            activeMenu === "home" ? "active-menu-item" : ""
                                        }`}
                                        onClick={() => menuClick("home")}
                                    >
                                        {t('navbar.menu.item1')}
                                    </Link>
                                </li>
                                <li>
                                    <Link to={"/bulletin"}
                                          className={`text-[#163578] hover:text-[#163578]  uppercase block py-2 px-4  font-bold text-base menu-item ${
                                              activeMenu === "bulletin" ? "active-menu-item" : ""
                                          }`}
                                          onClick={() => menuClick("bulletin")}
                                    >
                                        {t('navbar.menu.item4')}
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"/finance"}
                                        className={`text-[#163578] hover:text-[#163578]  uppercase block py-2 px-4  font-bold text-base menu-item ${
                                            activeMenu === "finance" ? "active-menu-item" : ""
                                        }`}
                                        onClick={() => menuClick("finance")}
                                    >
                                        {t('navbar.menu.item2')}
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"/external"}
                                        className={`text-[#163578] hover:text-[#163578]  uppercase block py-2 px-4  font-bold text-base menu-item ${
                                            activeMenu === "external" ? "active-menu-item" : ""
                                        }`}
                                        onClick={() => menuClick("external")}
                                    >
                                        {t('navbar.menu.item3')}
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"/moneymarket"}
                                        className={`text-[#163578] hover:text-[#163578]  uppercase block py-2 px-4  font-bold text-base menu-item ${
                                            activeMenu === "moneymarket" ? "active-menu-item" : ""
                                        }`}
                                        onClick={() => menuClick("moneymarket")}
                                    >
                                        {t('navbar.menu.item5')}
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"/other"}
                                        className={`text-[#163578] hover:text-[#163578]  uppercase block py-2 px-4  font-bold text-base menu-item ${
                                            activeMenu === "other" ? "active-menu-item" : ""
                                        }`}
                                        onClick={() => menuClick("other")}
                                    >
                                        {t('navbar.menu.item6')}
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={"/schedule"}
                                        className={`text-[#163578] hover:text-[#163578]  uppercase block py-2 px-4  font-bold text-base menu-item ${
                                            activeMenu === "schedule" ? "active-menu-item" : ""
                                        }`}
                                        onClick={() => menuClick("schedule")}
                                    >
                                        {t('navbar.menu.item7')}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className={"flex flex-row " + (menuOpen ? "" : " justify-end ")}>
                            <img src={"/icons/" + t('root.navbar-lng-logo')} alt="Change language"
                                 onClick={() => handleChangeLanguage()}
                                 className={menuOpen ? "h-6 w-auto mx-12 my-3 cursor-pointer" : "h-6 w-auto mx-2 cursor-pointer"}/>
                        </div>
                    </div>
                </nav>
            </>
        );
    }
;

export default Menu;